import { render, staticRenderFns } from "./registroCompletado.vue?vue&type=template&id=1dac1a04&scoped=true&"
import script from "./registroCompletado.vue?vue&type=script&lang=js&"
export * from "./registroCompletado.vue?vue&type=script&lang=js&"
import style0 from "./registroCompletado.vue?vue&type=style&index=0&id=1dac1a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dac1a04",
  null
  
)

export default component.exports